import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4db0d68b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dept_box common-page"
};
const _hoisted_2 = ["onClick", "src"];
import { reactive, ref } from "vue";
import deptDialog from "./components/dept-dialog.vue";
import { getDoctorDepListApi } from "@/service/modules/case";
export default /*#__PURE__*/_defineComponent({
  __name: 'dept',
  setup(__props) {
    const deptList = ref([]);
    const imageViewerShow = ref(false);
    const dialogVisible = ref(false);
    const imageViewerList = ref([]);
    const itemData = reactive({
      id: "",
      name: "",
      banner: ""
    });
    function handleCloseImageViewer() {
      imageViewerShow.value = false;
    }
    async function initData() {
      const res = await getDoctorDepListApi();
      deptList.value = res.data;
    }
    function handleShowPrevImg(img) {
      if (!img) return;
      imageViewerList.value = [img];
      imageViewerShow.value = true;
    }
    function handleTableItem(dialogType, itemDatas) {
      itemData.id = itemDatas.id;
      itemData.name = itemDatas.name;
      itemData.banner = itemDatas.banner;
      dialogVisible.value = true;
    }
    function closedeptDialog(e) {
      dialogVisible.value = false;
      initData();
    }
    initData();
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [deptList.value.length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: deptList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "deptName",
          label: "科室名称",
          align: "center"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.name), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "deptId",
          label: "科室ID",
          align: "center"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.id), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "deptId",
          label: "图片",
          align: "center"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("img", {
            class: "image_banner",
            onClick: $event => handleShowPrevImg(row.banner ? row.banner : ''),
            src: row.banner,
            alt: ""
          }, null, 8, _hoisted_2)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "deptId",
          label: "操作",
          align: "center"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => handleTableItem('edit', row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])) : _createCommentVNode("", true), imageViewerShow.value ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 1,
        teleported: true,
        "url-list": imageViewerList.value,
        onClose: handleCloseImageViewer
      }, null, 8, ["url-list"])) : _createCommentVNode("", true), _createVNode(deptDialog, {
        dialogVisible: dialogVisible.value,
        itemData: itemData,
        onCloseDialog: closedeptDialog
      }, null, 8, ["dialogVisible", "itemData"])]);
    };
  }
});